module.exports = __webpack_public_path__ + "media/images/d_4-1ff552252046d8ed41339b609857dfbc.jpeg";